import { pushNewView, updateSelectedCalendarEvent } from '../actions/timePanelStoreActions';
import { orchestrator } from 'satcheljs';
import { clickCalendarEvent, doubleClickCalendarEvent } from 'owa-conflicts-view';

export const clickCalendarEventOrchestrator = orchestrator(clickCalendarEvent, actionMessage => {
    updateSelectedCalendarEvent(actionMessage.id);
    pushNewView('EventDetails');
});

export const doubleClickCalendarEventOrchestrator = orchestrator(
    doubleClickCalendarEvent,
    actionMessage => {
        updateSelectedCalendarEvent(actionMessage.id);
        pushNewView('EventDetails');
    }
);
